import React, { useEffect, useRef, useState } from 'react';

// Signature on-load moment: masked line-by-line reveal
export const RevealText = ({ lines = [], delay = 0, stagger = 0.12, className = '', el: El = 'h1' }) => {
    return (
        <El className={className}>
            {lines.map((line, i) => (
                <span key={i} className="mask-line block">
                    <span
                        style={{
                            transform: 'translateY(110%)',
                            display: 'inline-block',
                            animation: `msdReveal 1.1s cubic-bezier(0.7,0,0.2,1) ${delay + i * stagger}s forwards`,
                        }}
                    >
                        {line}
                    </span>
                </span>
            ))}
            <style>{`
                @keyframes msdReveal {
                    0% { transform: translateY(110%); }
                    100% { transform: translateY(0%); }
                }
            `}</style>
        </El>
    );
};

// Word-level reveal used for body copy in view
export const RevealWords = ({ text, className = '' }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => entries.forEach((e) => e.isIntersecting && setVisible(true)),
            { threshold: 0.2 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, []);
    const words = text.split(' ');
    return (
        <p ref={ref} className={className}>
            {words.map((w, i) => (
                <span key={i} style={{ overflow: 'hidden', display: 'inline-block' }}>
                    <span
                        style={{
                            display: 'inline-block',
                            transform: visible ? 'translateY(0)' : 'translateY(100%)',
                            opacity: visible ? 1 : 0,
                            transition: `transform 0.9s cubic-bezier(0.7,0,0.2,1) ${i * 0.03}s, opacity 0.6s ease ${i * 0.03}s`,
                        }}
                    >
                        {w}&nbsp;
                    </span>
                </span>
            ))}
        </p>
    );
};
